// Textos de onuLifecycle (FE-03a, R06). Ligado em DICT.<lang>.app.onuLifecycle; lido por `useApp().t.app.onuLifecycle`.
// Modais do ciclo de vida da ONU: Ressincronizar, Substituir SN, Restaurar padrões e Mover ONU.
// Frases com negrito/monoespaçado no JSX vêm em pedaços (…A/…Bold/…B) para a ordem das palavras
// poder variar por idioma.

const pt = {
  close: 'Fechar',
  cancel: 'Cancelar',
  unknownError: 'erro desconhecido',
  kind: {
    registration: 'Registro da ONT',
    description: 'Descrição',
    profiles: 'Perfis (linha/serviço)',
    native_vlan: 'VLAN nativa',
    service_port: 'Service-port',
    service_port_record: 'Registro do service-port',
    wan_ip: 'WAN — obtenção de IP',
    wan_mode: 'WAN — modo (bridge/roteamento)',
  },
  status: { in_sync: 'Em dia', diverged: 'Diverge', blocked: 'Bloqueado', manual: 'Manual', deferred: 'Adiado' },
  mark: {
    failed: 'falhou', skipped: 'pulado', verified: 'confirmado na OLT',
    unverified: 'enviado, não confirmado', applied: 'aplicado',
  },
  table: { item: 'Item', desired: 'Desejado', live: 'Na OLT', state: 'Situação', optIn: 'opt-in' },
  confirmSerial: 'Para confirmar, digite o serial: ',
  // Ressincronizar
  resync: {
    title: 'Ressincronizar configuração',
    compareAgain: 'Comparar de novo',
    apply: (n) => `Aplicar ${n} alteração(ões)`,
    nothing: 'Nada a aplicar',
    explainerA: 'Compara o que o sistema tem como desejado (service-port, VLAN nativa configurada por aqui, descrição',
    explainerSerial: ' da ONU ',
    explainerB: ') com o que a OLT realmente tem e reaplica',
    explainerBold: ' só o que falta',
    explainerC: '. Nunca reprovisiona uma ONT que já existe na OLT; se a OLT perdeu o registro, ele é recriado com o mesmo ONT-ID.',
    loading: 'Lendo a configuração da porta na OLT…',
    blocked: 'Bloqueado — nada será escrito.',
    inSync: 'A OLT já está de acordo com o sistema.',
    pending: (changes, optIns) => `${changes} alteração(ões) pendente(s)${optIns ? ` + ${optIns} opcional(is) de WAN` : ''}.`,
    notRegistered: 'A ONT não está registrada na OLT.',
    includeWan: (n) => `Incluir a WAN (${n} item). `,
    wanWarnBold: 'Pode derrubar a conexão do cliente',
    wanWarnRest: ' enquanto o modo/IP é trocado (a ONU precisa estar online).',
    rApplied: 'aplicado(s)',
    rFailed: 'falha(s)',
    rSkipped: 'pulado(s)',
    rSep: '—',
    rVerified: 'confirmado por leitura da OLT',
    rUnverified: 'não confirmado por leitura',
    operation: (id) => `Operação ${id} (snapshot gravado antes da escrita).`,
    toastFailTitle: 'Ressincronização com falhas',
    toastFailDesc: (a, f) => `${a} aplicado(s), ${f} falha(s).`,
    toastUnverTitle: 'Ressincronização aplicada, mas não confirmada',
    toastUnverDesc: 'A leitura de volta da OLT não confirmou todos os itens.',
    toastOkTitle: 'Configuração ressincronizada',
    toastOkDesc: (n) => `${n} item(ns) aplicado(s) e confirmado(s) na OLT.`,
  },
  // Substituir ONU por SN
  replace: {
    title: 'Substituir ONU por SN',
    submit: 'Substituir',
    explainerA: 'O cliente trocou o aparelho. O ONT ',
    explainerBold: 'mantém o ONT-ID, os perfis e os service-ports',
    explainerB: ' na OLT; só o serial autorizado muda. O aparelho antigo perde o acesso e fica registrado no histórico desta ONU.',
    current: 'Serial atual',
    newSerial: 'Novo serial',
    format: 'Formato esperado: 4 caracteres do fabricante + 8 hexadecimais (ou os 16 hexadecimais da etiqueta).',
    same: 'O novo serial é igual ao atual.',
    awaiting: 'Aguardando autorização nesta OLT',
    searching: 'Buscando…',
    searchNow: 'Buscar agora na OLT',
    pendingError: (m) => `Não foi possível ler os pendentes: ${m}`,
    noPending: 'Nenhuma ONU pendente nesta OLT. Ligue o aparelho novo na mesma PON e busque de novo.',
    samePon: 'mesma PON',
    toastTitle: 'Serial substituído',
    toastDesc: (d) => `${d.old_serial} → ${d.new_serial}. O ONT manteve o ONT-ID ${d.ont_id}, os perfis e ${d.kept_service_ports} service-port(s); o serial antigo ficou no histórico.`,
  },
  // Restaurar padrões
  restore: {
    title: 'Restaurar padrões',
    submit: 'Restaurar padrões de fábrica',
    warnBold1: 'O cliente perde a internet.',
    warnA: ' O aparelho volta à configuração de fábrica (WAN/PPPoE, Wi-Fi e ajustes do próprio CPE se perdem) até ser reconfigurado. ',
    warnBold2: 'Não é um reinício',
    warnB: ' — para só reiniciar use “Reiniciar”.',
    expA: 'Envia ',
    expB: ' (sem ',
    expC: '). O registro na OLT (serial, ONT-ID, perfis, service-ports) é mantido, e os dados que este sistema guarda (VLANs, credenciais PPPoE) também — depois, “Ressincronizar configuração” reaplica o que a OLT perdeu.',
    kept: 'Comando aceito e registro confirmado na OLT (serial, ONT-ID e perfis mantidos).',
    notKept: 'Comando aceito, mas o registro NÃO foi confirmado na OLT.',
    staleCleared: 'O índice de service-port guardado já não existia na OLT e foi limpo (a VLAN desejada continua registrada).',
    resyncHint: (changes, optIns) => `A OLT já não tem ${changes} item(ns) que o sistema ainda tem como desejados${optIns ? ` e ${optIns} de WAN (a WAN só volta com a ONU online)` : ''}.`,
    openResync: 'Abrir “Ressincronizar configuração”',
    nothingToResync: 'Nada a ressincronizar no momento. A WAN/PPPoE do cliente precisa ser reaplicada quando a ONU voltar online (Ressincronizar → incluir WAN).',
    operation: (id) => `Operação ${id} (snapshot gravado antes do comando).`,
    toastWarnTitle: 'Padrões restaurados, com avisos',
    toastWarnFallback: 'O registro não foi confirmado na OLT.',
    toastOkTitle: 'Padrões de fábrica restaurados',
    toastOkDesc: 'O registro na OLT foi mantido; o CPE voltou à configuração de fábrica.',
  },
  // Mover ONU
  move: {
    title: 'Mover ONU',
    submit: 'Mover ONU',
    resume: 'Retomar movimentação',
    explainerA: 'A Huawei não tem “mover”: a ONT é ',
    explainerBold1: 'removida da porta de origem',
    explainerB: ' (service-ports e ',
    explainerC: ') e',
    explainerBold2: ' recriada na de destino',
    explainerD: ' com os mesmos perfis, VLANs e service-ports. É a ',
    explainerBold3: 'mesma ONU',
    explainerE: ' no sistema (cliente, zona/CTO e histórico mantidos). A fibra do cliente precisa estar na porta de destino. Só dentro da mesma OLT.',
    origin: 'Origem',
    onuSep: ' · ONU ',
    destBoard: 'Placa de destino',
    destPort: 'Porta PON de destino',
    select: 'Selecione…',
    ponsError: (m) => `Não foi possível listar as portas PON da OLT: ${m}`,
    planning: 'Lendo a origem e o destino na OLT…',
    resumableA: (steps) => `Há uma movimentação interrompida para este destino (passos concluídos: ${steps}).`,
    none: 'nenhum',
    resumableB: 'Confirmar ',
    resumableBold: 'retoma',
    resumableC: ' do ponto onde parou, com a configuração já gravada no snapshot.',
    removeTitle: (slot, port) => `Será removido da origem 0/${slot}/${port}`,
    ontId: (id) => `ONT-ID ${id}`,
    spCount: (n, vlans) => `${n} service-port(s)${n ? `: VLAN ${vlans}` : ''}`,
    nativeVlans: (n) => `${n} VLAN(s) nativa(s)`,
    createTitle: (slot, port) => `Será criado no destino 0/${slot}/${port}`,
    destId: (id, sameId) => `ONT-ID ${id}${sameId ? ' (o mesmo)' : ' (o de origem está ocupado)'}`,
    noFreeId: 'sem ONT-ID livre',
    profiles: (line, srv, desc) => `Perfis ${line}/${srv}${desc ? ` · “${desc}”` : ''}`,
    createCounts: (nv, sv) => `${nv} VLAN(s) nativa(s), ${sv} service-port(s)`,
    ackBold1: 'A ONU está online (ou não foi possível confirmar que está offline) na origem.',
    ackA: ' Se a fibra ainda estiver na porta de origem, o cliente',
    ackBold2: ' ficará sem serviço',
    ackB: ' até ela ser passada para a porta de destino. Entendo e quero mover mesmo assim.',
    partialA: (list) => `Já concluído antes da falha: ${list}.`,
    nothing: 'nada',
    partialB: 'A configuração está gravada no snapshot — ',
    partialBold: 'abrir “Mover ONU” de novo com o mesmo destino retoma',
    partialC: ' de onde parou.',
    movedOk: (slot, port, id) => `ONU movida para 0/${slot}/${port} (ONT-ID ${id}) e confirmada por leitura da OLT.`,
    movedMismatch: 'ONU movida, mas a leitura de confirmação encontrou divergências.',
    resumed: ' (movimentação retomada)',
    pendingWan: 'A WAN/PPPoE registrada ainda não foi reaplicada (exige a ONU online no destino): use “Ressincronizar configuração” com a WAN incluída.',
    operation: (id) => `Operação ${id} (snapshot gravado antes da primeira escrita).`,
    toastWarnTitle: 'ONU movida, com avisos',
    toastOkTitle: 'ONU movida',
    toastOkDesc: (from, to) => `0/${from.slot}/${from.port} → 0/${to.slot}/${to.port} (ONT-ID ${to.ont_id}), confirmada por leitura da OLT.`,
    step: {
      remove_service_port: 'Service-port removido da origem',
      delete_ont: 'ONT removida da origem',
      add_ont: 'ONT provisionada no destino',
      native_vlan: 'VLAN nativa recriada',
      service_port: 'Service-port recriado',
      readback: 'Leitura de confirmação do destino',
      database: 'Banco atualizado (mesma ONU, nova porta)',
      wan: 'WAN/PPPoE',
    },
  },
};

const en = {
  close: 'Close',
  cancel: 'Cancel',
  unknownError: 'unknown error',
  kind: {
    registration: 'ONT registration',
    description: 'Description',
    profiles: 'Profiles (line/service)',
    native_vlan: 'Native VLAN',
    service_port: 'Service-port',
    service_port_record: 'Service-port record',
    wan_ip: 'WAN — IP acquisition',
    wan_mode: 'WAN — mode (bridge/routing)',
  },
  status: { in_sync: 'In sync', diverged: 'Diverged', blocked: 'Blocked', manual: 'Manual', deferred: 'Deferred' },
  mark: {
    failed: 'failed', skipped: 'skipped', verified: 'confirmed on the OLT',
    unverified: 'sent, not confirmed', applied: 'applied',
  },
  table: { item: 'Item', desired: 'Desired', live: 'On the OLT', state: 'Status', optIn: 'opt-in' },
  confirmSerial: 'To confirm, type the serial: ',
  resync: {
    title: 'Resync configuration',
    compareAgain: 'Compare again',
    apply: (n) => `Apply ${n} change(s)`,
    nothing: 'Nothing to apply',
    explainerA: 'Compares what the system holds as desired (service-port, native VLAN configured here, description',
    explainerSerial: ' of ONU ',
    explainerB: ') with what the OLT actually has and reapplies',
    explainerBold: ' only what is missing',
    explainerC: '. It never re-provisions an ONT that already exists on the OLT; if the OLT lost the registration, it is recreated with the same ONT-ID.',
    loading: 'Reading the port configuration on the OLT…',
    blocked: 'Blocked — nothing will be written.',
    inSync: 'The OLT already matches the system.',
    pending: (changes, optIns) => `${changes} pending change(s)${optIns ? ` + ${optIns} optional WAN item(s)` : ''}.`,
    notRegistered: 'The ONT is not registered on the OLT.',
    includeWan: (n) => `Include WAN (${n} item). `,
    wanWarnBold: 'May drop the customer connection',
    wanWarnRest: ' while the mode/IP is changed (the ONU must be online).',
    rApplied: 'applied',
    rFailed: 'failed',
    rSkipped: 'skipped',
    rSep: '—',
    rVerified: 'confirmed by reading back from the OLT',
    rUnverified: 'not confirmed by read-back',
    operation: (id) => `Operation ${id} (snapshot saved before the write).`,
    toastFailTitle: 'Resync completed with failures',
    toastFailDesc: (a, f) => `${a} applied, ${f} failed.`,
    toastUnverTitle: 'Resync applied, but not confirmed',
    toastUnverDesc: 'The read-back from the OLT did not confirm all items.',
    toastOkTitle: 'Configuration resynced',
    toastOkDesc: (n) => `${n} item(s) applied and confirmed on the OLT.`,
  },
  replace: {
    title: 'Replace ONU by SN',
    submit: 'Replace',
    explainerA: 'The customer swapped the device. The ONT ',
    explainerBold: 'keeps its ONT-ID, profiles and service-ports',
    explainerB: ' on the OLT; only the authorized serial changes. The old device loses access and is recorded in this ONU\'s history.',
    current: 'Current serial',
    newSerial: 'New serial',
    format: 'Expected format: 4 vendor characters + 8 hexadecimal digits (or the 16 hexadecimal digits on the label).',
    same: 'The new serial is the same as the current one.',
    awaiting: 'Awaiting authorization on this OLT',
    searching: 'Searching…',
    searchNow: 'Search the OLT now',
    pendingError: (m) => `Could not read the pending ONUs: ${m}`,
    noPending: 'No pending ONU on this OLT. Connect the new device to the same PON and search again.',
    samePon: 'same PON',
    toastTitle: 'Serial replaced',
    toastDesc: (d) => `${d.old_serial} → ${d.new_serial}. The ONT kept ONT-ID ${d.ont_id}, its profiles and ${d.kept_service_ports} service-port(s); the old serial was kept in the history.`,
  },
  restore: {
    title: 'Restore defaults',
    submit: 'Restore factory defaults',
    warnBold1: 'The customer loses internet access.',
    warnA: ' The device returns to its factory configuration (WAN/PPPoE, Wi-Fi and the CPE\'s own settings are lost) until reconfigured. ',
    warnBold2: 'This is not a reboot',
    warnB: ' — to just reboot, use “Reboot”.',
    expA: 'Sends ',
    expB: ' (without ',
    expC: '). The OLT registration (serial, ONT-ID, profiles, service-ports) is kept, and so is the data this system stores (VLANs, PPPoE credentials) — afterwards, “Resync configuration” reapplies what the OLT lost.',
    kept: 'Command accepted and registration confirmed on the OLT (serial, ONT-ID and profiles kept).',
    notKept: 'Command accepted, but the registration was NOT confirmed on the OLT.',
    staleCleared: 'The stored service-port index no longer existed on the OLT and was cleared (the desired VLAN remains recorded).',
    resyncHint: (changes, optIns) => `The OLT no longer has ${changes} item(s) that the system still holds as desired${optIns ? ` and ${optIns} WAN item(s) (the WAN only comes back with the ONU online)` : ''}.`,
    openResync: 'Open “Resync configuration”',
    nothingToResync: 'Nothing to resync right now. The customer\'s WAN/PPPoE must be reapplied when the ONU is back online (Resync → include WAN).',
    operation: (id) => `Operation ${id} (snapshot saved before the command).`,
    toastWarnTitle: 'Defaults restored, with warnings',
    toastWarnFallback: 'The registration was not confirmed on the OLT.',
    toastOkTitle: 'Factory defaults restored',
    toastOkDesc: 'The OLT registration was kept; the CPE went back to its factory configuration.',
  },
  move: {
    title: 'Move ONU',
    submit: 'Move ONU',
    resume: 'Resume move',
    explainerA: 'Huawei has no “move”: the ONT is ',
    explainerBold1: 'removed from the source port',
    explainerB: ' (service-ports and ',
    explainerC: ') and',
    explainerBold2: ' recreated on the destination',
    explainerD: ' with the same profiles, VLANs and service-ports. It is the ',
    explainerBold3: 'same ONU',
    explainerE: ' in the system (customer, zone/CTO and history kept). The customer\'s fiber must be on the destination port. Same OLT only.',
    origin: 'Source',
    onuSep: ' · ONU ',
    destBoard: 'Destination board',
    destPort: 'Destination PON port',
    select: 'Select…',
    ponsError: (m) => `Could not list the OLT PON ports: ${m}`,
    planning: 'Reading the source and destination on the OLT…',
    resumableA: (steps) => `There is an interrupted move for this destination (completed steps: ${steps}).`,
    none: 'none',
    resumableB: 'Confirming ',
    resumableBold: 'resumes',
    resumableC: ' from where it stopped, with the configuration already saved in the snapshot.',
    removeTitle: (slot, port) => `Will be removed from source 0/${slot}/${port}`,
    ontId: (id) => `ONT-ID ${id}`,
    spCount: (n, vlans) => `${n} service-port(s)${n ? `: VLAN ${vlans}` : ''}`,
    nativeVlans: (n) => `${n} native VLAN(s)`,
    createTitle: (slot, port) => `Will be created on destination 0/${slot}/${port}`,
    destId: (id, sameId) => `ONT-ID ${id}${sameId ? ' (the same)' : ' (the source one is taken)'}`,
    noFreeId: 'no free ONT-ID',
    profiles: (line, srv, desc) => `Profiles ${line}/${srv}${desc ? ` · “${desc}”` : ''}`,
    createCounts: (nv, sv) => `${nv} native VLAN(s), ${sv} service-port(s)`,
    ackBold1: 'The ONU is online at the source (or it could not be confirmed offline).',
    ackA: ' If the fiber is still on the source port, the customer',
    ackBold2: ' will be without service',
    ackB: ' until it is moved to the destination port. I understand and want to move anyway.',
    partialA: (list) => `Already completed before the failure: ${list}.`,
    nothing: 'nothing',
    partialB: 'The configuration is saved in the snapshot — ',
    partialBold: 'opening “Move ONU” again with the same destination resumes',
    partialC: ' from where it stopped.',
    movedOk: (slot, port, id) => `ONU moved to 0/${slot}/${port} (ONT-ID ${id}) and confirmed by reading back from the OLT.`,
    movedMismatch: 'ONU moved, but the confirmation read-back found discrepancies.',
    resumed: ' (move resumed)',
    pendingWan: 'The recorded WAN/PPPoE has not been reapplied yet (requires the ONU online at the destination): use “Resync configuration” with WAN included.',
    operation: (id) => `Operation ${id} (snapshot saved before the first write).`,
    toastWarnTitle: 'ONU moved, with warnings',
    toastOkTitle: 'ONU moved',
    toastOkDesc: (from, to) => `0/${from.slot}/${from.port} → 0/${to.slot}/${to.port} (ONT-ID ${to.ont_id}), confirmed by reading back from the OLT.`,
    step: {
      remove_service_port: 'Service-port removed from the source',
      delete_ont: 'ONT removed from the source',
      add_ont: 'ONT provisioned on the destination',
      native_vlan: 'Native VLAN recreated',
      service_port: 'Service-port recreated',
      readback: 'Destination confirmation read-back',
      database: 'Database updated (same ONU, new port)',
      wan: 'WAN/PPPoE',
    },
  },
};

const es = {
  close: 'Cerrar',
  cancel: 'Cancelar',
  unknownError: 'error desconocido',
  kind: {
    registration: 'Registro de la ONT',
    description: 'Descripción',
    profiles: 'Perfiles (línea/servicio)',
    native_vlan: 'VLAN nativa',
    service_port: 'Service-port',
    service_port_record: 'Registro del service-port',
    wan_ip: 'WAN — obtención de IP',
    wan_mode: 'WAN — modo (bridge/enrutamiento)',
  },
  status: { in_sync: 'Al día', diverged: 'Diverge', blocked: 'Bloqueado', manual: 'Manual', deferred: 'Aplazado' },
  mark: {
    failed: 'falló', skipped: 'omitido', verified: 'confirmado en la OLT',
    unverified: 'enviado, no confirmado', applied: 'aplicado',
  },
  table: { item: 'Ítem', desired: 'Deseado', live: 'En la OLT', state: 'Situación', optIn: 'opt-in' },
  confirmSerial: 'Para confirmar, escriba el serial: ',
  resync: {
    title: 'Resincronizar configuración',
    compareAgain: 'Comparar de nuevo',
    apply: (n) => `Aplicar ${n} cambio(s)`,
    nothing: 'Nada que aplicar',
    explainerA: 'Compara lo que el sistema tiene como deseado (service-port, VLAN nativa configurada aquí, descripción',
    explainerSerial: ' de la ONU ',
    explainerB: ') con lo que la OLT realmente tiene y reaplica',
    explainerBold: ' solo lo que falta',
    explainerC: '. Nunca reprovisiona una ONT que ya existe en la OLT; si la OLT perdió el registro, se vuelve a crear con el mismo ONT-ID.',
    loading: 'Leyendo la configuración del puerto en la OLT…',
    blocked: 'Bloqueado — no se escribirá nada.',
    inSync: 'La OLT ya coincide con el sistema.',
    pending: (changes, optIns) => `${changes} cambio(s) pendiente(s)${optIns ? ` + ${optIns} opcional(es) de WAN` : ''}.`,
    notRegistered: 'La ONT no está registrada en la OLT.',
    includeWan: (n) => `Incluir la WAN (${n} ítem). `,
    wanWarnBold: 'Puede cortar la conexión del cliente',
    wanWarnRest: ' mientras se cambia el modo/IP (la ONU debe estar en línea).',
    rApplied: 'aplicado(s)',
    rFailed: 'fallo(s)',
    rSkipped: 'omitido(s)',
    rSep: '—',
    rVerified: 'confirmado por lectura de la OLT',
    rUnverified: 'no confirmado por lectura',
    operation: (id) => `Operación ${id} (snapshot guardado antes de la escritura).`,
    toastFailTitle: 'Resincronización con fallos',
    toastFailDesc: (a, f) => `${a} aplicado(s), ${f} fallo(s).`,
    toastUnverTitle: 'Resincronización aplicada, pero no confirmada',
    toastUnverDesc: 'La lectura de vuelta de la OLT no confirmó todos los ítems.',
    toastOkTitle: 'Configuración resincronizada',
    toastOkDesc: (n) => `${n} ítem(s) aplicado(s) y confirmado(s) en la OLT.`,
  },
  replace: {
    title: 'Sustituir ONU por SN',
    submit: 'Sustituir',
    explainerA: 'El cliente cambió el equipo. La ONT ',
    explainerBold: 'mantiene el ONT-ID, los perfiles y los service-ports',
    explainerB: ' en la OLT; solo cambia el serial autorizado. El equipo anterior pierde el acceso y queda registrado en el historial de esta ONU.',
    current: 'Serial actual',
    newSerial: 'Nuevo serial',
    format: 'Formato esperado: 4 caracteres del fabricante + 8 hexadecimales (o los 16 hexadecimales de la etiqueta).',
    same: 'El nuevo serial es igual al actual.',
    awaiting: 'Esperando autorización en esta OLT',
    searching: 'Buscando…',
    searchNow: 'Buscar ahora en la OLT',
    pendingError: (m) => `No se pudieron leer los pendientes: ${m}`,
    noPending: 'Ninguna ONU pendiente en esta OLT. Conecte el equipo nuevo a la misma PON y busque de nuevo.',
    samePon: 'misma PON',
    toastTitle: 'Serial sustituido',
    toastDesc: (d) => `${d.old_serial} → ${d.new_serial}. La ONT mantuvo el ONT-ID ${d.ont_id}, los perfiles y ${d.kept_service_ports} service-port(s); el serial anterior quedó en el historial.`,
  },
  restore: {
    title: 'Restaurar valores predeterminados',
    submit: 'Restaurar valores de fábrica',
    warnBold1: 'El cliente pierde el internet.',
    warnA: ' El equipo vuelve a la configuración de fábrica (WAN/PPPoE, Wi-Fi y ajustes del propio CPE se pierden) hasta ser reconfigurado. ',
    warnBold2: 'No es un reinicio',
    warnB: ' — para solo reiniciar use “Reiniciar”.',
    expA: 'Envía ',
    expB: ' (sin ',
    expC: '). El registro en la OLT (serial, ONT-ID, perfiles, service-ports) se mantiene, y los datos que este sistema guarda (VLANs, credenciales PPPoE) también — después, “Resincronizar configuración” reaplica lo que la OLT perdió.',
    kept: 'Comando aceptado y registro confirmado en la OLT (serial, ONT-ID y perfiles mantenidos).',
    notKept: 'Comando aceptado, pero el registro NO fue confirmado en la OLT.',
    staleCleared: 'El índice de service-port guardado ya no existía en la OLT y fue limpiado (la VLAN deseada sigue registrada).',
    resyncHint: (changes, optIns) => `La OLT ya no tiene ${changes} ítem(s) que el sistema aún tiene como deseados${optIns ? ` y ${optIns} de WAN (la WAN solo vuelve con la ONU en línea)` : ''}.`,
    openResync: 'Abrir “Resincronizar configuración”',
    nothingToResync: 'Nada que resincronizar por ahora. La WAN/PPPoE del cliente debe reaplicarse cuando la ONU vuelva en línea (Resincronizar → incluir WAN).',
    operation: (id) => `Operación ${id} (snapshot guardado antes del comando).`,
    toastWarnTitle: 'Valores restaurados, con avisos',
    toastWarnFallback: 'El registro no fue confirmado en la OLT.',
    toastOkTitle: 'Valores de fábrica restaurados',
    toastOkDesc: 'El registro en la OLT se mantuvo; el CPE volvió a la configuración de fábrica.',
  },
  move: {
    title: 'Mover ONU',
    submit: 'Mover ONU',
    resume: 'Reanudar movimiento',
    explainerA: 'Huawei no tiene “mover”: la ONT es ',
    explainerBold1: 'eliminada del puerto de origen',
    explainerB: ' (service-ports y ',
    explainerC: ') y',
    explainerBold2: ' recreada en el de destino',
    explainerD: ' con los mismos perfiles, VLANs y service-ports. Es la ',
    explainerBold3: 'misma ONU',
    explainerE: ' en el sistema (cliente, zona/CTO e historial se mantienen). La fibra del cliente debe estar en el puerto de destino. Solo dentro de la misma OLT.',
    origin: 'Origen',
    onuSep: ' · ONU ',
    destBoard: 'Tarjeta de destino',
    destPort: 'Puerto PON de destino',
    select: 'Seleccione…',
    ponsError: (m) => `No se pudieron listar los puertos PON de la OLT: ${m}`,
    planning: 'Leyendo el origen y el destino en la OLT…',
    resumableA: (steps) => `Hay un movimiento interrumpido para este destino (pasos completados: ${steps}).`,
    none: 'ninguno',
    resumableB: 'Confirmar ',
    resumableBold: 'reanuda',
    resumableC: ' desde donde se detuvo, con la configuración ya guardada en el snapshot.',
    removeTitle: (slot, port) => `Se eliminará del origen 0/${slot}/${port}`,
    ontId: (id) => `ONT-ID ${id}`,
    spCount: (n, vlans) => `${n} service-port(s)${n ? `: VLAN ${vlans}` : ''}`,
    nativeVlans: (n) => `${n} VLAN(s) nativa(s)`,
    createTitle: (slot, port) => `Se creará en el destino 0/${slot}/${port}`,
    destId: (id, sameId) => `ONT-ID ${id}${sameId ? ' (el mismo)' : ' (el de origen está ocupado)'}`,
    noFreeId: 'sin ONT-ID libre',
    profiles: (line, srv, desc) => `Perfiles ${line}/${srv}${desc ? ` · “${desc}”` : ''}`,
    createCounts: (nv, sv) => `${nv} VLAN(s) nativa(s), ${sv} service-port(s)`,
    ackBold1: 'La ONU está en línea (o no se pudo confirmar que esté fuera de línea) en el origen.',
    ackA: ' Si la fibra aún está en el puerto de origen, el cliente',
    ackBold2: ' quedará sin servicio',
    ackB: ' hasta que sea pasada al puerto de destino. Entiendo y quiero mover de todos modos.',
    partialA: (list) => `Ya completado antes del fallo: ${list}.`,
    nothing: 'nada',
    partialB: 'La configuración está guardada en el snapshot — ',
    partialBold: 'abrir “Mover ONU” de nuevo con el mismo destino reanuda',
    partialC: ' desde donde se detuvo.',
    movedOk: (slot, port, id) => `ONU movida a 0/${slot}/${port} (ONT-ID ${id}) y confirmada por lectura de la OLT.`,
    movedMismatch: 'ONU movida, pero la lectura de confirmación encontró divergencias.',
    resumed: ' (movimiento reanudado)',
    pendingWan: 'La WAN/PPPoE registrada aún no fue reaplicada (exige la ONU en línea en el destino): use “Resincronizar configuración” con la WAN incluida.',
    operation: (id) => `Operación ${id} (snapshot guardado antes de la primera escritura).`,
    toastWarnTitle: 'ONU movida, con avisos',
    toastOkTitle: 'ONU movida',
    toastOkDesc: (from, to) => `0/${from.slot}/${from.port} → 0/${to.slot}/${to.port} (ONT-ID ${to.ont_id}), confirmada por lectura de la OLT.`,
    step: {
      remove_service_port: 'Service-port eliminado del origen',
      delete_ont: 'ONT eliminada del origen',
      add_ont: 'ONT aprovisionada en el destino',
      native_vlan: 'VLAN nativa recreada',
      service_port: 'Service-port recreado',
      readback: 'Lectura de confirmación del destino',
      database: 'Base actualizada (misma ONU, nuevo puerto)',
      wan: 'WAN/PPPoE',
    },
  },
};

export const ONU_LIFECYCLE_I18N = { pt, en, es };
